import React, { useState } from 'react';
import { Box, Typography, Grid, Card } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from 'recharts';
import { ErrorOutline } from '@mui/icons-material';

const TargetOverview = ({ targetData }) => {
  const {
    achieved_info,
    remaining_info,
    target_info,
    section_header_display_title,
    month_and_year_name,
  } = targetData || {};

  const getSectionData = (info) => ({
    value: info?.quantity || 0,
    color: info?.color || '#FFCC00',
    title: info?.section_title || 'No Title',
    prefix_uom: info?.prefix_uom || '',
    suffix_uom: info?.suffix_uom || '',
  });

  const achievedData = getSectionData(achieved_info);
  const remainingData = getSectionData(remaining_info);
  const targetDataInfo = getSectionData(target_info);

  const pieData = [achievedData, remainingData];

  return (
    <Card
      sx={{
        backgroundColor: '#FFFFFF',
        padding: '10px',
        borderRadius: 2,
        width: '100%',
        maxWidth: '1200px',
        height: '100%',
      }}
    >
      <Box
        display='flex'
        justifyContent='space-between'
        width={'100%'}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
          {section_header_display_title}
        </Typography>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>
          {month_and_year_name}
        </Typography>
      </Box>

      {targetData ? (
        <Box sx={{ alignItems: 'center', width: '100%' }}>
          <Grid
            item
            sx={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ResponsiveContainer
              width='100%'
              height={200}
            >
              <PieChart>
                <Pie
                  dataKey='value'
                  startAngle={180}
                  endAngle={0}
                  data={pieData}
                  cx='50%'
                  cy='80%'
                  innerRadius={85}
                  outerRadius={100}
                  stroke='none'
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.color}
                      style={{ cursor: 'pointer' }}
                    />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
              }}
              justifyContent={'center'}
            >
              <Typography
                variant='body1'
                sx={{
                  fontWeight: 'bold',
                  fontSize: 16,
                  textAlign: 'center',
                }}
              >
                {achievedData?.title}
              </Typography>
              <Box
                display='flex'
                alignItems='center'
                justifyContent={'center'}
              >
                <Typography
                  variant='body2'
                  color='textSecondary'
                  sx={{ marginLeft: 1 }}
                >
                  {achievedData?.prefix_uom}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    color: '#F59C1E',
                  }}
                >
                  {achievedData?.value}
                </Typography>
                <Typography
                  variant='body2'
                  color='textSecondary'
                  sx={{ marginLeft: 1 }}
                >
                  {achievedData?.suffix_uom}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent='space-between'
          >
            <Grid item>
              <Typography fontWeight={500}>{targetDataInfo.title}</Typography>
              <Box
                display='flex'
                alignItems='center'
              >
                <Typography
                  variant='body2'
                  color='textSecondary'
                  sx={{ marginLeft: 1 }}
                >
                  {targetDataInfo.prefix_uom}
                </Typography>
                <Typography
                  sx={{ fontSize: '1.5rem', fontWeight: 700, color: '#1976d2' }}
                >
                  {targetDataInfo.value}
                </Typography>
                <Typography
                  variant='body2'
                  color='textSecondary'
                  sx={{ marginLeft: 1 }}
                >
                  {targetDataInfo.suffix_uom}
                </Typography>
              </Box>
            </Grid>

            <Grid item>
              <Typography fontWeight={500}>{remainingData.title}</Typography>
              <Box
                display='flex'
                alignItems='center'
              >
                <Typography
                  variant='body2'
                  color='textSecondary'
                  sx={{ marginLeft: 1 }}
                >
                  {remainingData.prefix_uom}
                </Typography>
                <Typography
                  sx={{ fontSize: '1.5rem', fontWeight: 700, color: '#D32F2F' }}
                >
                  {remainingData.value}
                </Typography>
                <Typography
                  variant='body2'
                  color='textSecondary'
                  sx={{ marginLeft: 1 }}
                >
                  {remainingData.suffix_uom}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          sx={{ height: '100%', minHeight: 200 }}
        >
          <Box textAlign='center'>
            <ErrorOutline sx={{ fontSize: 60, color: '#B2B5C4' }} />
            <Typography
              sx={{ fontSize: 16, fontWeight: 600, color: '#8E92A8', mt: 1 }}
            >
              No Target Data Found
            </Typography>
          </Box>
        </Grid>
      )}
    </Card>
  );
};

export default TargetOverview;
